import React from 'react';
import './FilterPill.css';
import { AssetUrls } from 'config/assets';

interface FilterPillProps {
  label: string;
  active: boolean;
  onToggle: () => void;
  /** Rendered but inert: the value does not apply here (kept visible, never hidden) */
  disabled?: boolean;
  title?: string;
  /** Optional leading mark (the 9px finish swatch on finish pills) */
  icon?: React.ReactNode;
}

const FilterPill: React.FC<FilterPillProps> = ({ label, active, onToggle, disabled = false, title, icon }) => {
  return (
    <button
      type="button"
      className={`filter-pill ${active ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={active}
      aria-disabled={disabled || undefined}
      title={title}
    >
      {icon}
      <span>{label}</span>
      {active && (
        <img
          src={AssetUrls.icons.dropdowns.close}
          alt="close"
          className="filter-pill-close"
        />
      )}
    </button>
  );
};

export default FilterPill;
